import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { closeDrawer } from "../../actions/drawerActions";
import ActionEditorHook from "../qd/actions/ActionEditorHook";
import { createActionTemplateAndCloseDrawer, saveActionTemplateAndCloseDrawer } from "../../actions/actionTemplateActions";
import { QD_URL } from "../../constants/systemConstants";
import * as TEMPLATE from "../../constants/templateConstants";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import { useNavigate } from "react-router-dom";
import {createEditorOrigin, EDITOR_TYPES} from "../../utilities/editorInstanceOwnership";

const ActionCreateEditDrawerHook = (props) => {
    const {
        createMode = false,
        templateKey = "",
        templateId = null,
        templateMode = ""
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const filter = useSelector(state => state.filter[TEMPLATE.FILTER.current.action]);
    const versionsFilter = useSelector(state => 
        state.filter[TEMPLATE.FILTER[TEMPLATE.MODE.VERSIONS][TEMPLATE.TYPE.ACTION]] || {});
    const editorInstanceId = useSelector(state => state.actionEditor.instanceId);

    const handleCloseDrawer = () => {
        dispatch(closeDrawer());
    };

    const handleSave = async (actionTemplate) => {
        const requestOwner = createEditorOrigin(EDITOR_TYPES.ACTION, editorInstanceId);
        if (createMode) {
            return dispatch(createActionTemplateAndCloseDrawer(
                actionTemplate,
                filter,
                onCreateSuccess,
                requestOwner
            ));
        }
        return dispatch(saveActionTemplateAndCloseDrawer(
            actionTemplate,
            filter,
            versionsFilter,
            templateMode,
            requestOwner
        ));
    };

    const onCreateSuccess = () => {
        navigate(QD_URL + "/actions", { replace: true });
    };

    return (
        <div id="ActionCreateEditDrawer-container-div" style={{height: "100%"}}>
            <ArgoAppBarHook
                title={createMode ? "Create Action" : "Edit Action"}
                showMenuIconButton={false}
                noIcon={true}
                isDrawer={true}
                width={actionCreateEditDrawerProps.width}
            />

            <div style={{height: '64px'}}></div>

            <ActionEditorHook
                createMode={createMode}
                cancel={handleCloseDrawer}
                save={handleSave}
                templateKey={templateKey}
                templateId={templateId}
                templateMode={templateMode}
                width={actionCreateEditDrawerProps.width}
                scrollTo="ActionCreateEditDrawer-container-div"
            />
        </div>
    );
};

ActionCreateEditDrawerHook.propTypes = {
    filter: PropTypes.object,
    templateKey: PropTypes.string,
    templateId: PropTypes.number,
    templateMode: PropTypes.string,  // mode can be VERSIONS
    createMode: PropTypes.bool,
};

const actionCreateEditDrawerProps = {
    opensecondary: true,
    width: "90%",
    docked: false,
    anchor: "right"
};

export default ActionCreateEditDrawerHook;
export { actionCreateEditDrawerProps };
